import React from "react";
// nodejs library that concatenates classes
// nodejs library to set properties for components
import PropTypes from "prop-types";
import { Box } from "@mui/material";
// @material-ui/core components
// @material-ui/icons

// core components
import cardStyle from "../../assets/jss/components/CardStyle.jsx";

function Card({ ...props }) {
  const { sx, className, children, plain, carousel, ...rest } = props;
  return (
    <Box
      component="div"
      className="Card"
      sx={[
        cardStyle.card,
        plain && cardStyle.cardPlain,
        carousel && cardStyle.cardCarousel,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    >
      {children}
    </Box>
  );
}

Card.propTypes = {
  // classes: PropTypes.object.isRequired,
  sx: PropTypes.object,
  plain: PropTypes.bool,
  carousel: PropTypes.bool,
};

export default Card;
